import { useEffect, useState } from 'react';
import { api } from '@/lib/api';
import { getTelegramUser } from '@/env';
import type { Me } from '@/lib/types';
import { etb } from '@/lib/money';

export function Profile() {
    const tgUser = getTelegramUser();
    const [me, setMe] = useState<Me | null>(null);
    const [tab, setTab] = useState<'overview' | 'wins'>('overview');
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        let cancelled = false;
        api.get<{ data: Me }>('/me')
            .then((res) => {
                if (!cancelled) setMe(res.data.data);
            })
            .catch((e) => {
                if (!cancelled) setError(e instanceof Error ? e.message : 'Could not load profile');
            });
        return () => {
            cancelled = true;
        };
    }, []);

    return (
        <div className="lobby profile-page">
            <div className="lobby-connected">{me ? '✓ Connected' : tgUser ? 'Signing in…' : 'Open inside Telegram'}</div>

            <div className="profile-hero">
                <div className="profile-avatar">👤</div>
                <div className="profile-who">
                    <strong>{me?.name || tgUser?.name || 'Player'}</strong>
                    <span>Player Profile</span>
                </div>
                <div className="profile-bal">
                    <span>Balance</span>
                    <strong>ETB {me ? etb(me.wallet.balance) : '—'}</strong>
                </div>
            </div>

            <div className="profile-stats">
                <div>
                    <strong>{me?.total_wins ?? 0}</strong>
                    <span>Total Wins</span>
                </div>
                <div>
                    <strong>ETB {me ? etb(me.total_winnings ?? 0) : 0}</strong>
                    <span>Winnings</span>
                </div>
                {me?.phone_masked && (
                    <p className="profile-phone">☎ {me.phone_masked}</p>
                )}
            </div>

            <div className="profile-tabs">
                <button className={tab === 'overview' ? 'on' : ''} onClick={() => setTab('overview')}>
                    Overview
                </button>
                <button className={tab === 'wins' ? 'on' : ''} onClick={() => setTab('wins')}>
                    Wins
                </button>
            </div>

            {error && <div className="lobby-empty">{error}</div>}

            {tab === 'overview' && (
                <div className="profile-detail">
                    <div>
                        <span>Games Played</span>
                        <strong>{me?.games_played ?? 0}</strong>
                    </div>
                    <div>
                        <span>Total Winnings</span>
                        <strong>ETB {me ? etb(me.total_winnings ?? 0) : 0}</strong>
                    </div>
                    <div>
                        <span>Current Balance</span>
                        <strong>ETB {me ? etb(me.wallet.balance) : 0}</strong>
                    </div>
                </div>
            )}

            {tab === 'wins' && (
                <p className="lobby-empty">Wins show here after Finance-confirmed BINGO payouts.</p>
            )}
        </div>
    );
}
